import { Facet } from '../../../../collaborators/fetch-products/new-contract/types';

const orderFacets = (facetOptions: Facet[]): Facet[] => {
  return facetOptions.sort((a: Facet, b: Facet) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (isNaN(a.order)) {
      a.order = Infinity;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (isNaN(b.order)) {
      b.order = Infinity;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return a.order - b.order;
  });
};

export default orderFacets;
